export const NOTIFY_TYPES = {
  error: 'danger',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',
  info: 'info',
  dark: 'dark',
  light: 'light',
};

export const NOTIFY_COLORS = {
  error: 'red',
  info: 'green',
};
